import { API_ENDPOINTS } from "../../../Api/apiEndPoints";
import axiosInstance from "../../../Api/axiosInstance";

export const getOrderList = async (params: Record<string, any>) => {
  const response = await axiosInstance.get(API_ENDPOINTS.POB.GET_ORDER_LIST, {
    params: params,
  });

  console.log(
    "🚀 ~ POBRepository.ts:9 ~ getOrderList ~ response:",
    response.data
  );

  return response?.data;
};

export const getOrderListByID = async (
  id: any,
  params: Record<string, any>
) => {
  const response = await axiosInstance.get(
    `${API_ENDPOINTS.POB.GET_ORDER_LIST_BY_ID}/${id}`,
    { params: params }
  );

  console.log("🚀 ~ POBRepository.ts:26 ~ response:", response);

  return response?.data;
};

export const updateAcceptOrder = async (id: any, body: any) => {
  const response = await axiosInstance.put(
    `${API_ENDPOINTS.POB.EDIT_ACCEPT_ORDER}/${id}`,
    body
  );

  console.log("🚀 ~ POBRepository.ts:26 ~ response:", response);

  return response?.data;
};

export const deleteOrder = async (id: any) => {
  const response = await axiosInstance.delete(
    `${API_ENDPOINTS.POB.DELETE_ORDER}/${id}`
  );

  console.log("🚀 ~ POBRepository.ts:47 ~ deleteOrder ~ response:", response);
  return response?.data;
};

export const printOrder = async (id: any, body?: string | any) => {
  const response = await axiosInstance.post(
    `${API_ENDPOINTS.POB.PRINT_ORDER}/${id}`,
    body
  );
  console.log("🚀 ~ POBRepository.ts:56 ~ printOrder ~ response:", response);

  return response?.data;
};

export const productByPricebookId = async (id: any) => {
  const response = await axiosInstance.get(
    `${API_ENDPOINTS.POB.PRODUCTS_BY_PRICEBOOKID}/${id}`
  );

  console.log(
    "🚀 ~ POBRepository.ts:65 ~ productByPricebookId ~ response:",
    response
  );

  return response?.data;
};

export const addOrderLine = async (id: number, body: any) => {
  console.log(
    `id ORDER ID--------->${id}-------->body ORDER LINES:${JSON.stringify(
      body
    )}`
  );

  return axiosInstance.post(`${API_ENDPOINTS.POB.ADD_ORDER_LINE}/${id}`, body);
};
export const updateOrderLine = async (id: number, body: any) => {
  console.log(
    `id UPDATE ORDER ID--------->${id}-------->body UPDATE ORDER LINES:${JSON.stringify(
      body
    )}`
  );

  return axiosInstance.put(`${API_ENDPOINTS.POB.EDIT_ORDER_LINE}/${id}`, body);
};
export const deleteOrderLine = async (id: number, body: any) => {
  console.log(
    `id DELETE ORDER ID--------->${id}-------->body DELETE ORDER LINES:${JSON.stringify(
      body
    )}`
  );

  return axiosInstance.delete(`${API_ENDPOINTS.POB.DELETE_ORDER_LINE}/${id}`, {
    data: body,
  });
};

export const getEmployeeFilterList = async (params: Record<string, any>) => {
  const response = await axiosInstance.get(
    API_ENDPOINTS.POB.GET_EMPLOYEE_FILTER,
    { params }
  );

  console.log(
    "🚀 ~ POBRepository.ts:86 ~ getEmployeeFilterList ~ response:",
    response
  );

  return response?.data;
};

export const getOrderStatus = async () => {
  const response = await axiosInstance.get(API_ENDPOINTS.POB.GET_ORDER_STATUS);

  console.log(
    "🚀 ~ POBRepository.ts:101 ~ getOrderStatus ~ response:",
    response
  );

  return response?.data;
};

export const getCalculateOrderLinesSubTotal = async (
  params: Record<string, any>
) => {
  const response = await axiosInstance.get(
    API_ENDPOINTS.POB.GET_ORDER_LINE_SUBTOTAL,
    {
      params: params,
    }
  );

  console.log("🚀 ~ POBRepository.ts:117 ~ response:", response);

  return response?.data;
};

export const getOrderTypesData = async (params: Record<string, any>) => {
  const response = await axiosInstance.get(API_ENDPOINTS.POB.GET_ORDER_TYPES);

  console.log(
    "🚀 ~ POBRepository.ts:145 ~ getOrderTypesData ~ response:",
    response
  );

  return response?.data;
};

export const getOutletFiltersData = async (params: Record<string, any>) => {
  const response = await axiosInstance.get(
    API_ENDPOINTS.POB.GET_OUTLET_FILTERS,
    {
      params: params,
    }
  );

  console.log(
    "🚀 ~ POBRepository.ts:161 ~ getOutletFiltersData ~ response:",
    response
  );

  return response?.data;
};

// REJECT_ORDER

export const rejectOrder = async (id: number, body: any) => {
  console.log(
    `id UPDATE ORG UNIT ID--------->${id}-------->body UPDATE ORDER LINES:${JSON.stringify(
      body
    )}`
  );

  return axiosInstance.put(`${API_ENDPOINTS.POB.REJECT_ORDER}/${id}`, body);
};
